import React, { useRef, useState, useEffect } from 'react';
import { useChatStream } from '../hooks/useChatStream';
import { ChatLauncher, ChatHeader, ChatMessage, ChatComposer, CHAT_Z_INDEX } from './chat/ChatParts';
import { BookingCard } from './chat/BookingCard';

export const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const { messages, streaming, send, sessionId } = useChatStream();
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' });
  }, [messages, open]);

  if (!open) return <ChatLauncher onOpen={() => setOpen(true)} />;

  return (
    <div
      data-testid="chat-widget-panel"
      className="fixed bottom-48 right-4 sm:right-6 w-[calc(100vw-2rem)] sm:w-96 h-[30rem] max-h-[calc(100vh-14rem)] bg-white rounded-2xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden"
      style={{ zIndex: CHAT_Z_INDEX }}
    >
      <ChatHeader onClose={() => setOpen(false)} />

      <div ref={scrollRef} data-testid="chat-messages" className="flex-1 overflow-y-auto p-4 space-y-3 bg-sand-50">
        {messages.map((m, i) => (
          m.kind === 'booking'
            ? <BookingCard key={m.id} message={m} sessionId={sessionId} />
            : <ChatMessage key={m.id} message={m} pending={streaming && i === messages.length - 1} />
        ))}
      </div>

      <ChatComposer onSend={send} disabled={streaming} />
    </div>
  );
};
